import { v4 as generateUuid } from 'uuid';

const pageCloseBlockers = new Set<string>();

export const isPageCloseBlocked = (): boolean => {
  return pageCloseBlockers.size > 0;
};

window.addEventListener('beforeunload', (event: BeforeUnloadEvent): void => {
  if (isPageCloseBlocked()) {
    event.preventDefault();

    event.returnValue = '';
  }
});

export const blockPageClose = (): string => {
  const blockerId = generateUuid();

  pageCloseBlockers.add(blockerId);

  return blockerId;
};

export const unblockPageClose = (blockerId: string): void => {
  pageCloseBlockers.delete(blockerId);
};
